/**
 * Exposes the current header height as the --header-height CSS custom property
 * on :root, updated on load, resize, and header size changes. Sections that
 * need a viewport-minus-header sizing (e.g. hero) use
 * `calc(100svh - var(--header-height))`.
 */
(() => {
  const root = document.documentElement;
  const header = document.querySelector('.shopify-section-group-header-group, header');
  if (!header) return;

  const update = () => {
    root.style.setProperty('--header-height', header.offsetHeight + 'px');
  };

  update();
  window.addEventListener('resize', update, { passive: true });

  if ('ResizeObserver' in window) {
    new ResizeObserver(update).observe(header);
  }
})();
